module.exports = __webpack_public_path__ + "static/img/cultureItem2.44ff6da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/cultureItem2.png
// module id = +2tH
// module chunks = 0